import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Heading, styles as dsStyles } from '@frontend/design-system';
import { LocationPicker, LocationPickerProps } from './location-picker';

const styles = {
  truncate: dsStyles.truncate,
  tray: css({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    maxHeight: '100%',
    height: '100%',
    background: theme.colors.white,
    padding: theme.spacing(3),
  }),
  heading: css({
    display: 'flex',
    gap: theme.spacing(1.5),
    alignItems: 'center',
    color: theme.colors.neutral90,
    fontWeight: theme.font.weight.bold,
  }),
  mainHeading: css({
    marginBottom: theme.spacing(1.5),
  }),
  text: css({
    color: theme.colors.neutral50,
    fontSize: theme.font.size.medium,
    fontWeight: theme.font.weight.regular,
  }),
};

export const LocationPickerTray = ({
  currentLocation,
  hideCloseActions,
  onClose,
  onChangeLocation,
  itemSections,
  searchLocations,
}: LocationPickerProps) => {
  return (
    <div css={styles.tray}>
      <Heading level={2} css={[styles.heading, styles.mainHeading]}>
        Select a Location
      </Heading>

      <LocationPicker
        currentLocation={currentLocation}
        hideCloseActions={hideCloseActions}
        onClose={onClose}
        onChangeLocation={onChangeLocation}
        itemSections={itemSections}
        searchLocations={searchLocations}
      />
    </div>
  );
};
